import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-jam",
  "use": "google-jam-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"google-jam\"><g clip-path=\"url(#google-jam_clip0_2_62)\"><rect width=\"16\" height=\"16\" rx=\"2\" fill=\"#F87B2B\" /><path d=\"M8 2h3.5v3H8V2zm0 4h3.5v3.5H8V6z\" fill=\"#fff\" /><path d=\"M7.5 14a4 4 0 003.97-3.5H7V6.03A4 4 0 007.5 14z\" fill=\"#fff\" /></g><defs><clipPath id=\"google-jam_clip0_2_62\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol